import { Injectable } from '@angular/core';
import { clearGlobalApiToken, getGlobalApiToken, setGlobalApiToken } from '../api-token.util';

@Injectable({
  providedIn: 'root',
})
export class ApiTokenService {
  private token = '';

  setToken(token: string): void {
    this.token = token || '';
    setGlobalApiToken(this.token);
  }

  getToken(): string {
    if (this.token) {
      return this.token;
    }

    this.token = getGlobalApiToken();
    return this.token;
  }

  clearToken(): void {
    this.token = '';
    clearGlobalApiToken();
  }
}
